<template>
  <SidebarComponent />
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <h1>Ordini</h1>
          <p>Totale percorsi vendute: {{ totalPromotionsSold }}</p>
          <p>Totale in euro di prodotti: {{ totalInEuro }} €</p>
        </div>

        <div class="loader" v-if="isLoading">
          <h4>SINCRONIZZAZIONE IN CORSO</h4>
        </div>

        <div class="search-and-filter-container">
          <div class="search-email-container">
            <input type="text" v-model="searchEmail" placeholder="Cerca per email utente..." @input="filterOrders">
          </div>
          <input type="date" v-model="startDate">
          <input type="date" v-model="endDate">
          <button class="staff-button-neutral" @click="fetchOrders">Recupera Ordini</button>

          <button class="staff-button-neutral" @click="toggleFoodFilter">Mostra/Nascondi ordini da spedire</button>
          <button class="staff-button-neutral" @click="toggleSpecificProductFilter">Mostra ordini con prodotti specifici (ID 59400, 59396)</button>

        </div>

        <!-- Selezione dello stato e pulsante per applicare -->
        <div class="bulk-actions">
          <select v-model="bulkStatus">
            <option value="">Seleziona uno stato</option>
            <option value="pending">In attesa di pagamento</option>
            <option value="processing">In lavorazione</option>
            <option value="on-hold">In sospeso</option>
            <option value="completed">Completato</option>
            <option value="cancelled">Cancellato</option>
            <option value="refunded">Rimborsato</option>
            <option value="failed">Fallito</option>
            <option value="in-spedizione">In Spedizione</option>
            <option value="spedito">Spedito</option>
            <option value="bonifico-pagato">Bonifico pagato</option>
          </select>
          <button class="staff-button-positive" @click="applyBulkStatus" :disabled="!bulkStatus || selectedOrders.length === 0">APPLICA</button>

          <button class="staff-button-neutral" @click="filterOrdersByStatus" :disabled="!bulkStatus">FILTRA</button>

        </div>

        <div class="tickets">
          <table>
            <thead>
              <tr>
                <th><input type="checkbox" @change="toggleSelectAll($event)"></th> <!-- Checkbox per selezionare tutti -->
                <th>ID ORDINE</th>
                <th>DATA</th>
                <th>STATO</th>
                <th>EMAIL</th>
                <th>COGNOME</th>
                <th>TOTALE</th>
                <th>AZIONI</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="order in filteredOrders" :key="order.id">
                <td><input type="checkbox" :value="order.id" v-model="selectedOrders"></td> <!-- Checkbox per selezionare singolo ordine -->
                <td>{{ order.id }}</td>
                <td>{{ formatDate(order.date_created) }}</td>
                <td>
                  <select v-model="order.status" @change="() => updateOrderStatus(order.id, order.status)">
                    <option value="pending">In attesa di pagamento</option>
                    <option value="processing">In Lavorazione</option>
                    <option value="on-hold">In sospeso</option> 
                    <option value="completed">Completato</option>
                    <option value="cancelled">Cancellato</option>
                    <option value="refunded">Rimborsato</option>
                    <option value="failed">Fallito</option>
                    <option value="in-spedizione">In Spedizione</option>
                    <option value="spedito">Spedito</option>
                    <option value="bonifico-pagato">Bonifico pagato</option>
                  </select>
                </td>                <td>{{ order.billing.email }}</td>
                <td>{{ order.billing.last_name }}</td>
                <td>{{ order.total }}</td>
                <td>
                  <button class="staff-button-neutral" @click="viewOrderDetails(order.id)"><span class="material-icons">visibility</span></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="pagination">
          <button class="staff-button-neutral" :disabled="currentPage <= 1" @click="prevPage">Prec.</button>
          <span>Pagina {{ currentPage }} di {{ pageCount }}</span>
          <button class="staff-button-neutral" :disabled="currentPage >= pageCount" @click="nextPage">Succ.</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modale Dettagli Ordine -->
  <div v-if="selectedOrder" class="modal" @click.self="closeModal()">
    <div class="modal-content">
      <span class="close" @click="closeModal()">&times;</span>
      <h2>Dettagli Ordine</h2>
      <p><strong>Numero Ordine:</strong> {{ selectedOrder.id }}</p>
      <p><strong>Data Ordine:</strong> {{ formatDate(selectedOrder.date_created) }}</p>
      <p><strong>Nome:</strong> {{ selectedOrder.billing.first_name }} {{ selectedOrder.billing.last_name }}</p>
      <p><strong>Indirizzo di Spedizione:</strong> {{ selectedOrder.shipping.address_1 }} {{ selectedOrder.shipping.address_2 }}, {{ selectedOrder.shipping.city }}, {{ selectedOrder.shipping.state }} {{ selectedOrder.shipping.postcode }}, {{ selectedOrder.shipping.country }}</p>
      <p><strong>Email:</strong> {{ selectedOrder.billing.email }}</p>
      <p><strong>Telefono:</strong> {{ selectedOrder.billing.phone }}</p>
      <p><strong>Stato:</strong> {{ selectedOrder.status }}</p>
      <p><strong>Totale:</strong> {{ selectedOrder.total }} €</p>
      <h3>Prodotti Acquistati:</h3>
      <ul>
        <li v-for="item in selectedOrder.line_items" :key="item.id">
          Q.tà: {{ item.quantity }} - {{ item.name }} - Prezzo: {{ item.price }} €
        </li>
      </ul>
    </div>
  </div>
</template>




<script>
import SidebarComponent from '../SidebarComponent.vue'; // Assicurati che il percorso sia corretto
import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";

// Configurazione Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDp3djBGu504OhM7uGg1jiA6MsC4ZWQszs",
  authDomain: "fusco-fit-connect-4b731.firebaseapp.com",
  databaseURL: "https://fusco-fit-connect-4b731-default-rtdb.firebaseio.com",
  projectId: "fusco-fit-connect-4b731",
  storageBucket: "fusco-fit-connect-4b731.appspot.com",
  messagingSenderId: "691335746060",
  appId: "1:691335746060:web:868eaf5af62d389727d429",
  measurementId: "G-FL6QKY34E9"
};

// Inizializza Firebase
const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);

export default {
  components: {
    SidebarComponent,
  },

  data() {
    const today = new Date();
    const yesterday = new Date(today);

    yesterday.setDate(yesterday.getDate() - 1);

    const formattedToday = today.toISOString().slice(0, 10);
    const formattedYesterday = yesterday.toISOString().slice(0, 10);

    return {
      orders: [],
      searchEmail: '',
      currentPage: 1,
      totalPromotionsSold: 0,
      totalInEuro: 0,
      startDate: formattedYesterday,
      endDate: formattedToday,
      ordersPerPage: 25,
      selectedOrder: null,
      isLoading: false,
      selectedOrders: [], // Array per gli ordini selezionati
      bulkStatus: '', // Stato selezionato dalla select per applicare o filtrare
      isSpecificProductFilterActive: false, // Nuova proprietà per il filtro specifico
      productCategorySlugs: {
      // 'id_prodotto': 'slug_categoria',
      '53215': 'food',
      '52167': 'food',
      '52160': 'food',
      '52150': 'food',
      '52073': 'food',
      '52063': 'food',
      '52025': 'food',
      '51955': 'food',
      // altri mappature prodotto-slug...
      '53296': 'percorsi',
      '53295': 'percorsi',
      '53294': 'percorsi',
      '53293': 'percorsi',
      '52968': 'percorsi',
      '56989': 'percorsi',
      '58410': 'percorsi',

      // altri mappature prodotto-slug...
      '59933': 'percorsi-foodspring',
      '59930': 'percorsi-foodspring',
      '59927': 'percorsi-foodspring',
      '59924': 'percorsi-foodspring',
      '59915': 'percorsi-foodspring',
      '59906': 'percorsi-foodspring',

            // altri mappature prodotto-slug...
            '60039': 'barrette-foodspring',
            '60036': 'barrette-foodspring',
            '60032': 'barrette-foodspring',
            '60022': 'barrette-foodspring',
            '60018': 'barrette-foodspring',
            '60014': 'barrette-foodspring',
            '60011': 'barrette-foodspring',
            '60006': 'barrette-foodspring',
            '59998': 'barrette-foodspring',
            '59992': 'barrette-foodspring',
            '59865': 'barrette-foodspring',
            '61072': 'barrette-foodspring',
            '61062': 'barrette-foodspring',

            '60507': 'barrette-foodspring',
            '60473': 'barrette-foodspring',


      // altri mappature prodotto-slug...
      '60199': 'cookie-foodspring',
      '60115': 'cookie-foodspring',
      '60113': 'cookie-foodspring',

      // altri mappature prodotto-slug...
      '60119': 'preparati-foodspring',
      '60117': 'preparati-foodspring',

      // altri mappature prodotto-slug...
      '59880': 'integratori-foodspring',
      '59883': 'integratori-foodspring',
      '59886': 'integratori-foodspring',
      '59889': 'integratori-foodspring',
      '59893': 'integratori-foodspring',
      '59896': 'integratori-foodspring',
      '59899': 'integratori-foodspring',
      '59902': 'integratori-foodspring',

      '61216': 'integratori-foodspring',
      '61210': 'integratori-foodspring',
      '60937': 'integratori-foodspring',
      '60931': 'integratori-foodspring',

      '60414': 'integratori-foodspring',
      '60404': 'integratori-foodspring',
      '60402': 'integratori-foodspring',
      '60372': 'integratori-foodspring',
      '60926': 'integratori-foodspring',



      // altri mappature prodotto-slug...
      '1181': 'integratori',
      '24692': 'integratori',
      '2628': 'integratori',
      '2645': 'integratori',
      '24693': 'integratori',
      '24694': 'integratori',
      '24695': 'integratori',
      '24701': 'integratori',
      '24752': 'integratori',
      '2648': 'integratori',
      '13032': 'integratori',
      '24702': 'integratori',
      '24745': 'integratori',
      '24749': 'integratori',
      '24750': 'integratori',
      '63199': 'integratori',

      

      // altri mappature prodotto-slug...
      '53265': 'promozioni',
      '53263': 'promozioni',
      '56601': 'promozioni',
      '57663': 'promozioni',
      '58640': 'promozioni',
    },
      isFoodFilterActive: false,
      filteredByStatus: '', // Stato utilizzato per il filtro
    };
  },


    computed: {
  filteredOrders() {
    let orders = this.orders.filter(order => order.status !== 'cancelled');

    // Filtro per ordini con prodotti "food", "percorsi", ecc.
    if (this.isFoodFilterActive) {
      orders = orders.filter(order =>
        order.line_items.some(item =>
          ['food', 'percorsi', 'integratori', 'promozioni', 'percorsi-foodspring', 'barrette-foodspring', 'cookie-foodspring', 'preparati-foodspring', 'integratori-foodspring']
            .includes(this.productCategorySlugs[item.product_id])
        )
      );
    }

    // Nuovo filtro per gli ordini contenenti i prodotti specifici con ID 59400 o 59396
    if (this.isSpecificProductFilterActive) {
      orders = orders.filter(order =>
        order.line_items.some(item => [59400, 59396].includes(item.product_id))
      );
    }

    // Filtro per stato selezionato (se applicato con il bottone 'Filtra')
    if (this.filteredByStatus) {
      orders = orders.filter(order => order.status === this.filteredByStatus);
    }

    // Filtro per email
    orders = orders.filter(order => 
      order.billing.email.toLowerCase().includes(this.searchEmail.toLowerCase())
    );

    const start = (this.currentPage - 1) * this.ordersPerPage;
    const end = this.currentPage * this.ordersPerPage;

    return orders.slice(start, end);
  },




    pageCount() {
      return Math.ceil(this.orders.filter(order => order.billing.email.toLowerCase().includes(this.searchEmail.toLowerCase())).length / this.ordersPerPage);
    }
  },

  methods: {

    toggleSpecificProductFilter() {
    this.isSpecificProductFilterActive = !this.isSpecificProductFilterActive;
  },
  
    async updateOrderStatus(orderId, newStatus) {
      this.isLoading = true;
      try {
        const updateOrderStatusFunction = httpsCallable(functions, 'updateOrderStatus');
        const result = await updateOrderStatusFunction({ orderId, newStatus });
        if (result.data.success) {
          console.log('Stato ordine aggiornato con successo');
        } else {
          console.error('Errore nell\'aggiornamento dello stato dell\'ordine:', result.data.error);
        }
      } catch (error) {
        console.error('Errore nell\'aggiornamento dello stato dell\'ordine:', error);
      } finally {
        this.isLoading = false;
      }
    },

    async applyBulkStatus() {
      if (!this.bulkStatus) {
        alert("Seleziona uno stato per applicarlo");
        return;
      }

      this.isLoading = true;
      try {
        const updateOrderStatusFunction = httpsCallable(functions, 'updateOrderStatus');
        const promises = this.selectedOrders.map(orderId =>
          updateOrderStatusFunction({ orderId, newStatus: this.bulkStatus })
        );

        await Promise.all(promises);

        console.log("Stato di tutti gli ordini selezionati aggiornato con successo");

        this.selectedOrders = []; // Svuota la selezione dopo l'aggiornamento
      } catch (error) {
        console.error("Errore durante l'aggiornamento degli ordini selezionati:", error);
      } finally {
        this.isLoading = false;
      }
    },

    // Funzione per filtrare gli ordini per stato
    filterOrdersByStatus() {
      if (!this.bulkStatus) {
        alert("Seleziona uno stato per filtrare gli ordini");
        return;
      }
      this.filteredByStatus = this.bulkStatus; // Imposta lo stato con cui filtrare
    },

    toggleSelectAll(event) {
      if (event.target.checked) {
        this.selectedOrders = this.filteredOrders.map(order => order.id);
      } else {
        this.selectedOrders = [];
      }
    },

    async fetchOrders() {
      this.isLoading = true;
      try {
        const formattedStartDate = `${this.startDate}T00:00:00`;
        const formattedEndDate = `${this.endDate}T23:59:59`;

        const fetchOrdersFunction = httpsCallable(functions, 'fetchOrders');
        const result = await fetchOrdersFunction({
          startDate: formattedStartDate,
          endDate: formattedEndDate,
        });

        if (result.data.success) {
          this.orders = result.data.orders;
          this.calculateTotalPromotionsSold();
          this.calculateTotalInEuro();
        } else {
          console.error('Errore nel recupero degli ordini:', result.data.error);
        }
      } catch (error) {
        console.error('Errore nel recupero degli ordini:', error);
      } finally {
        this.isLoading = false;
      }
    },

    calculateTotalPromotionsSold() {
      let total = 0;
      this.orders.forEach(order => {
        order.line_items.forEach(item => {
          if (this.productCategorySlugs[item.product_id] === 'percorsi-foodspring') {
            total += item.quantity;
          }
        });
      });
      this.totalPromotionsSold = total;
    },

    calculateTotalInEuro() {
  let total = 0;
  
  // Array delle categorie da considerare
  const categories = ['food', 'percorsi', 'integratori', 'promozioni', 'percorsi-foodspring', 'barrette-foodspring', 'cookie-foodspring', 'preparati-foodspring', 'integratori-foodspring'];

  this.orders.forEach(order => {
    // Controlla se l'ordine contiene almeno un prodotto che appartiene alle categorie specificate
    let hasProductInCategory = order.line_items.some(item =>
      categories.includes(this.productCategorySlugs[item.product_id])
    );
    
    if (hasProductInCategory) {
      total += parseFloat(order.total);
    }
  });

  // Salva il totale formattato
  this.totalInEuro = total.toFixed(2);
},


    toggleFoodFilter() {
      this.isFoodFilterActive = !this.isFoodFilterActive;
    },

    viewOrderDetails(orderId) {
      const order = this.orders.find(o => o.id === orderId);
      if (order) {
        this.selectedOrder = order;
      }
    },

    closeModal() {
      this.selectedOrder = null;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('it-IT');
    },

    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },

    nextPage() {
      if (this.currentPage < this.pageCount) this.currentPage++;
    },
  },

  mounted() {
    this.fetchOrders();
  }
};
</script>

  


<style scoped>

.search-and-filter-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px; /* Crea uno spazio di 20px tra gli elementi figli */
}

.search-email-container {
  flex-grow: 1; /* Fa in modo che il campo di ricerca si espanda per occupare lo spazio disponibile */
}


.modal {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #282828;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  max-width: 600px;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}


.pagination {
text-align: center;
margin-top: 20px;
color: #3f3f3f;

}

input[type="text"] {
  border-radius: 24px;  /* Angoli stondati */
  background-color: #f1f1f116;  /* Sfondo grigio */
  padding: 11px;  /* Spazio interno */
  border: 1px solid #4c4c4c;  /* Bordo */
  color:rgb(211, 211, 211)
}


.search-email-container {
  color:#4c4c4c;
}

.material-icons {
  margin-left: 0px;
  margin-right: 0px;
}


</style>
